module.exports = {
    isEmpty: function (value) {
        return value === undefined || value === '';
    },
};
